import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const ruleManagementService = {
  //获取规则分页列表
  getList(params) {
    return request({
      url: REST_SERVICE.rule.getRulePage,
      method: 'get',
      params
    });
  },
  // 添加规则
  addRule(params) {
    return request({
      url: REST_SERVICE.rule.addRule,
      method: 'post',
      data: params
    });
  },
  // 删除规则
  deleteRuleById(params) {
    return request({
      url: REST_SERVICE.rule.deleteRuleById,
      method: 'post',
      data: params
    });
  },
  // 根据id修改规则
  updateRuleById(params) {
    return request({
      url: REST_SERVICE.rule.updateRuleById,
      method: 'post',
      data: params
    });
  }
};
export default ruleManagementService;
